<template>
    <div>
        <h1>News</h1>
        <h2>Small update (2020.04.22):</h2>
        <p>The matchmaking is still correct for 10.8 patch!</p>
        <p>Added matchmaking algo at the bottom of the site.</p>
        <p>Fixed bug: when you eliminated player the app sometimes would not show up last safe player as unsafe.</p>
        <p>Fixed bug on android: eliminating player does not select the name anymore</p>
        <h2>Small update (2020.05.01):</h2>
        <p>Adjusted matchmaking to the current live matchmaking from the game. Riot changed that after someone dies, the matchmaking history gets deleted, which means you can fight the same person again.</p>
        <p>Added button to switch between matching or eliminating, which should help mobile users (especially iOS).</p>
        <p>Added sub-pages to not make the main page cluttered</p>
        <p>Fixed meta data</p>
    </div>
</template>

<script>
    export default {
        name: 'News'
    }
</script>